import React from "react";
import Styled from "styled-components";
function ContactForm() {
  return (
    <MainCont>
      <Form>
        <InputCont>
          <Input
            style={{ outlineColor: "$ffb400" }}
            placeholder="Your Name"
          ></Input>
          <Input placeholder="Your Email"></Input>
        </InputCont>
        <Input style={{ width: "100%" }} placeholder="Subject"></Input>
        <Textarea placeholder="Your Message" rows={8}></Textarea>
        <div style={{ display: "flex", justifyContent:"space-between" }}>
          <Btn>
            Submit
            <Colapse>
              <i className="fas fa-paper-plane"></i>
            </Colapse>
          </Btn>
          <div style={{display:"flex",listStyle:"none",fontSize:"35px",justifyContent:"space-around",alignItems:"center"}}>
              <a href="https://github.com/mayank190821" target="_blank" style={{margin:"0 2rem",color:"white", cursor:"pointer",textDecoration:"none"}}>
                <i className="fab fa-github"></i>
              </a>
              <a href="https://www.linkedin.com/in/mayank-bhugra/" target="_blank"style={{margin:"0 2rem" ,color:"white",cursor:"pointer",textDecoration:"none"}} >
                <i className="fab fa-linkedin"></i>
              </a>
          </div>
        </div>
      </Form>
    </MainCont>
  );
}
const MainCont = Styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
`;
const Form = Styled.form`
    display:flex;
    flex-direction:column;
    gap:1rem;
    width:50vw;
    height:58vh;
    justify-content:center;
    padding:1rem;
    @media (max-width:425px){
      height:70vh;
      width:100vw;
    }
`;
const Input = Styled.input`
    height:3rem;
    background:#323232;
    border-radius:10px;
    text-indent:10px;
    font-size:1rem;
    border:none;
    color:white;
    position:relative;
    width:48%;
    outline:none;
    letter-spacing:1px;
    &:focus{
        border:1px solid #ffb400;
    }
    @media (max-width:425px){
      width:100%;
    }
    
`;
const InputCont = Styled.div`
    // width:50%;
    color:white;
    display:flex;
    justify-content:space-between;
    @media (max-width:425px){
      flex-direction:column;
      gap:1rem;
    }
`;
const Textarea = Styled.textarea`
    background:#323232;
    border:none;
    border-radius:10px;
    // width:50%;
    padding:20px;
    color:white;
    font-size:1rem;
`;
const Colapse = Styled.span`
  border-radius:50%;
  height:50px;
  width:50px;
  z-index:1;
  justify-content:center;
  align-items:center;
  display:flex;
  position:relative;
  color:white;
  background:#ffb400;
  border:1px solid #ffb400;
  margin-left:10px;
  pointer-events:none;
  cursor:pointer;
  @media (max-width:768px){
    width:40px;
    height:40px;
    margin-left : 5px;
  }
`;
const Btn = Styled.button`
  border:2px solid #ffb400;
  border-radius:100px;
  height:3.5rem;
  font-size:25px;
  background:transparent;
  color:white;
  padding-left:2rem;
  padding-right:0;
  font-weight:500;
  z-index:5;
  cursor:pointer;
  display:flex;
  letter-spacing:1px;
  width:12rem;
  justify-content:space-between;
  align-items:center;
  &:hover{
    transition:1s all;
    background-color:#ffb400;
  }
  @media (max-width:768px){
    height:3rem;
    padding-left:1rem;
  }
  @media (max-width:425px){
    width:fit-content;
  }
`;
export default ContactForm;
